
import setupStickyNav from './modules/sticky-nav.js';
import setupSlider from "./modules/slider.js";
import setupSmoothScroll from "./modules/smooth-scroll.js";
import setupFaq from "./modules/faq.js";
import setupUserTypes from "./modules/user-types.js";

setupSlider();
setupStickyNav();
setupSmoothScroll();
setupFaq();
setupUserTypes();
